module.exports = require("/Users/dylan/personal-website/src/utils/typography.jsx")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 296
// module chunks = 231608221292675